<template>
    <div :class="['dw-card', 'dw-fade-in', cardClass]" :style="cardStyle" :data-widget-id="widget.id">
        <div class="dw-header" @pointerdown="$emit('headerPointerdown', $event)">
            <div class="dw-header-left">
                <div class="dw-icon-wrap" :style="{ background: widget.accentBg, color: widget.accent }">
                    <i :class="['bi', widget.icon]"></i>
                </div>
                <span class="dw-title">{{ $t(widget.titleKey) }}</span>
            </div>
            <div class="dw-header-right">
                <slot name="actions" />
                <i class="bi bi-grip-vertical dw-drag-handle"></i>
            </div>
        </div>
        <div class="dw-body">
            <div v-if="loading" class="dw-loading">
                <div class="dw-loading-spinner"></div>
            </div>
            <slot v-else />
        </div>
        <div class="dw-resize-handle" @pointerdown.stop.prevent="$emit('resizePointerdown', $event)">
            <i class="bi bi-arrows-angle-expand"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BaseWidget',
    props: {
        widget: { type: Object, required: true },
        cardClass: { type: [String, Array, Object], default: '' },
        cardStyle: { type: [String, Object], default: () => ({}) },
        loading: { type: Boolean, default: false },
    },
    emits: ['headerPointerdown', 'resizePointerdown'],
};
</script>

<style>
.dw-loading {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 80px;
}
.dw-loading-spinner {
    width: 24px;
    height: 24px;
    border: 2px solid rgba(var(--panel-accent-rgb, 0, 122, 255), 0.15);
    border-top-color: var(--panel-accent);
    border-radius: 50%;
    animation: dw-loading-spin 0.7s linear infinite;
}
@keyframes dw-loading-spin {
    to { transform: rotate(360deg); }
}
</style>
